<template>
  <div>
    <ModifyComparesion>
      <template slot="after">
        <TablePublic :colLists="pickColLists" :tableData="currContent" :paginationFlag="false"> </TablePublic>
      </template>
      <template slot="before">
        <TablePublic :colLists="pickColLists" :tableData="orignalContent" :paginationFlag="false"> </TablePublic>
      </template>
    </ModifyComparesion>
  </div>
</template>
<script>
import ModifyComparesion from '@/components/ModifyComparesion'
import TablePublic from '@/components/tablePublic'
export default {
  name: 'ModifcationDetail',
  components: {
    TablePublic,
    ModifyComparesion,
  },
  props: {
    currContent: {
      type: Array,
      default: () => [],
    },
    orignalContent: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
  },
  data() {
    return {

      pickColLists: [
        {
          prop: 'pickingBatchBizNo',
          label: '采摘批次',
          isTrue: true,
        },
        {
          prop: 'totalQuantity',
          label: '满筐总筐数',
          isTrue: true,
        },
        {
          prop: 'tailContainerWeight',
          label: '尾筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'totalNetWeight',
          label: '总净重（斤）',
          isTrue: true,
        },
      ],
    }
  },
  methods: {
   
  },
}
</script>
